// CorpManagement.jsx의 STATUS_OPTIONS와 같은 라벨(이 화면 전용, constants.js의 accountStatus는
// CreateManager.jsx/CorpManagementDetail.jsx가 영문 라벨 그대로 쓰고 있어 건드리지 않는다).
export const STATUS_OPTIONS = [
  { value: 'APPROVED', label: '승인' },
  { value: 'APPROVAL_PENDING', label: '대기' },
  { value: 'REFUSED', label: '불가' },
  { value: 'WITHDREW', label: '탈퇴' },
];

// constants.js의 planTypes와 동일한 값(LITE/PRO). 라벨은 제품 등급명이라 번역하지 않는다.
export const PLAN_TYPE_OPTIONS = [
  { value: 'LITE', label: 'LITE' },
  { value: 'PRO', label: 'PRO' },
];

export const DEFAULT_ROW_STATUS = 'APPROVAL_PENDING';
export const DEFAULT_ROW_PLAN_TYPE = 'LITE';
